import { useNavigate } from "react-router-dom";
import { colors } from "../theme";

interface HeaderProps {
  title: string;
  showBack?: boolean;
  showClose?: boolean;
  onBack?: () => void;
  onClose?: () => void;
}

export default function Header({ title, showBack, showClose, onBack, onClose }: HeaderProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }
    // VEN-35: deep-link entries from Telegram (invite / bet / rematch) replace
    // the history stack, so window.history.length is 1 and navigate(-1)
    // becomes a no-op. Fall back to Home so Back always does *something*.
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  const handleClose = () => {
    if (onClose) onClose();
    else navigate("/");
  };

  const iconButtonStyle: React.CSSProperties = {
    width: 40,
    height: 40,
    borderRadius: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: colors.surface,
    border: `1px solid ${colors.border}`,
    color: colors.white,
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1,
    padding: 0,
    cursor: "pointer",
    flexShrink: 0,
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "12px 16px",
        minHeight: 56,
        gap: 12,
      }}
    >
      <div style={{ width: 40, display: "flex", justifyContent: "flex-start" }}>
        {showBack && (
          <button
            type="button"
            aria-label="Back"
            onClick={handleBack}
            style={iconButtonStyle}
          >
            {"\u2190"}
          </button>
        )}
      </div>

      <div
        style={{
          flex: 1,
          textAlign: "center",
          fontSize: 17,
          fontWeight: 700,
          color: colors.white,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </div>

      <div style={{ width: 40, display: "flex", justifyContent: "flex-end" }}>
        {showClose && (
          <button
            type="button"
            aria-label="Close"
            onClick={handleClose}
            style={iconButtonStyle}
          >
            {"\u2715"}
          </button>
        )}
      </div>
    </div>
  );
}
